<template>
  <div class="body-wrapper">
    <div class="body-wrapper table-poll">
      <div class="table-wrapper">
        <spinner
          class="spinner"
          line-fg-color="#00796b"
          :size="100"
          :line-size="6"
          v-if="loading"
        ></spinner>
        <div v-if="!loading">
          <button @click="addNewReminder" class="btn btn-filter">
            Dodaj podsetnik
          </button>
          <div class="filter-search">
            <div
              ref="filterDropdown"
              class="dropdown"
              :class="{ show: dropdownActive }"
            >
              <button
                @click="openFilter"
                class="btn btn-secondary btn-filter"
                type="button"
                id="dropdownMenuButton"
                data-toggle="dropdown"
                aria-haspopup="true"
                aria-expanded="false"
                :class="{ 'red-filter': filterActive }"
              >
                Filter
              </button>

              <div
                class="dropdown-menu"
                :class="{ show: dropdownActive }"
                aria-labelledby="dropdownMenuButton"
              >
                <div class="contractor-filter" v-if="allContractors.length > 0">
                  <h6>Serviser</h6>
                  <select
                    class="form-control custom-select"
                    v-model="selectedContractor"
                  >
                    <option value="-1">Svi serviseri</option>
                    <option
                      v-for="contractor in allContractors"
                      :key="contractor.id"
                      :value="contractor.id"
                      >{{ contractor.name }}</option
                    >
                  </select>
                  <hr />
                </div>

                <div
                  class="contractor-filter"
                  v-if="allInfrastructure.length > 0"
                >
                  <h6>Infrastruktura</h6>
                  <select
                    class="form-control custom-select"
                    v-model="selectedCategory"
                  >
                    <option value="-1">Sve infrastrukture</option>
                    <option
                      v-for="infra in allInfrastructure"
                      :key="infra.id"
                      :value="infra.id"
                      >{{ infra.name }}</option
                    >
                  </select>
                  <hr />
                </div>
                <div class="dates contractor-filter">
                  <h6>Datum od</h6>
                  <div class="date">
                    <datetime
                      @focus="errorOccurred = false"
                      v-model="dateFrom"
                      type="date"
                      input-class="form-control form-control-lg"
                      placeholder="Izaberite datum"
                      hidden-name="webstorm"
                      format="dd.MM.yyyy"
                      :phrases="{
                        ok: 'U redu',
                        cancel: 'Otkaži'
                      }"
                    ></datetime>
                    <i class="fas fa-times" @click="dateFrom = null"></i>
                  </div>
                  <h6>Datum do</h6>
                  <div class="date">
                    <datetime
                      @focus="errorOccurred = false"
                      v-model="dateTo"
                      :min-datetime="dateFrom"
                      type="date"
                      input-class="form-control form-control-lg"
                      placeholder="Izaberite datum"
                      hidden-name="webstorm"
                      format="dd.MM.yyyy"
                      :phrases="{
                        ok: 'U redu',
                        cancel: 'Otkaži'
                      }"
                    ></datetime>
                    <i class="fas fa-times" @click="dateTo = null"></i>
                  </div>
                  <div
                    class="validation-text"
                    v-if="
                      dateTo != null &&
                        dateTo != '' &&
                        dateFrom != null &&
                        dateFrom != '' &&
                        dateTo < dateFrom
                    "
                  >
                    Krajnji datum ne može biti pre početnog.
                  </div>
                  <hr />
                </div>
                <div class="show-deleted-filter">
                  <h6>
                    Prikaži obrisane podsetnike
                  </h6>

                  <input
                    type="checkbox"
                    name="showDeleted"
                    v-model="includeDeletedReminders"
                  />
                </div>

                <div class="footer-filter">
                  <button
                    @click="filterChange"
                    class="btn btn-secondary btn-go left"
                    type="button"
                    :disabled="
                      dateTo != null &&
                        dateTo != '' &&
                        dateFrom != null &&
                        dateFrom != '' &&
                        dateTo < dateFrom
                    "
                  >
                    Primeni filter
                  </button>
                  <button
                    @click="refreshTableAndFilterDropdown"
                    class="btn btn-secondary btn-go"
                    type="button"
                  >
                    Resetuj filter
                  </button>
                </div>
              </div>
            </div>
          </div>
          <div class="radio-group">
            <input
              type="radio"
              id="private"
              name="privacy"
              value="list"
              v-model="view"
            />
            <!-- <label for="private"></label> -->
            <!-- <i class="fas fa-th-list" @click="view = 'list'"></i> -->
            <i class="fas fa-list-ul" @click="view = 'list'"></i>
            <input
              type="radio"
              id="public"
              name="privacy"
              value="calendar"
              v-model="view"
            />
            <i class="fas fa-calendar-alt" @click="view = 'calendar'"></i>
            <!-- <label for="public"></label> -->
          </div>
          <data-table
            v-if="!loading"
            v-show="view == 'list'"
            :columns="table.tableColumns"
            :tableData="tableData"
            :options="table.tableOptions"
            :slotNextInstance="'nextInstance'"
            :slotNameActionCommunityReminders="'action'"
            @row-click="openReminderDetails"
          ></data-table>
          <calendar v-show="view == 'calendar'"></calendar>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import DataTable from '@/components/community/Table';
import { mapMutations, mapState, mapActions } from 'vuex';
import Calendar from '@/components/community/Calendar';
import { Datetime } from 'vue-datetime';
import { DateTime } from 'luxon';

export default {
  components: {
    DataTable,
    Calendar,
    Datetime
  },
  data() {
    return {
      table: {
        tableColumns: ['title', 'description', 'nextInstance', 'action'],
        tableOptions: {
          filterable: true,
          headings: {
            title: 'Naziv',
            description: 'Opis',
            nextInstance: 'Sledeće izvršavanje',
            action: 'Akcije'
          },
          texts: {
            filter: '',
            filterPlaceholder: 'Pretraži',
            count: '',
            noResults: 'Ne postoje podsetnici'
          },
          sortable: []
        }
      },
      view: 'list',
      events: [],
      categories: [],
      allInfrastructure: [],
      selectedCategory: -1,
      allContractors: [],
      selectedContractor: -1,
      filterActive: false,
      dropdownActive: false,
      dateFrom: null,
      dateTo: null,
      includeDeletedReminders: false
    };
  },
  computed: {
    ...mapState(['loading']),
    ...mapState('modal', ['modalVisible']),
    ...mapState('table', ['tableColumns', 'tableData'])
  },
  async created() {
    // alerts Community view that card is opened so
    // proper badge is loaded
    this.cardOpened();
    // set infra categories
    /*
     * setting badge of active view (polls)
     * */
    this.setTableBadge('fas fa-calendar-check');

    //loading data to table
    this.allInfrastructure = await this.getAllInfrastructure({
      communityId: this.$store.getters.getActiveCommunity.community_id,
      returnOnlyData: true
    });
    this.allContractors = await this.getAllContractors(false);
    const routeParams = this.$route.query;
    if (Object.keys(routeParams).length === 0) {
      const currentDate = DateTime.local();
      await this.getCommunityReminders({
        communityId: this.$store.getters.getActiveCommunity.id,
        filters: {
          dateTo: currentDate
            .set({ year: currentDate.year + 1 })
            .toFormat('yyyy-MM-dd')
        }
      });
    } else {
      this.filterActive = true;
      if (routeParams.contractorId && Number(routeParams.contractorId) >= 0) {
        this.selectedContractor = routeParams.contractorId;
      }
      if (routeParams.dateFrom) {
        let dateFromFormatted = DateTime.fromFormat(
          routeParams.dateFrom,
          'yyyy-MM-dd'
        );
        dateFromFormatted = dateFromFormatted.plus({ days: 1 });
        this.dateFrom = dateFromFormatted.toISO();
      }
      if (routeParams.dateTo) {
        let dateToFormatted = DateTime.fromFormat(
          routeParams.dateTo,
          'yyyy-MM-dd'
        );
        dateToFormatted = dateToFormatted.plus({ days: 1 });
        this.dateTo = dateToFormatted.toISO();
      }
      if (routeParams.communityInfrastructureId) {
        this.selectedCategory = routeParams.communityInfrastructureId;
      }
      await this.getCommunityReminders({
        communityId: this.$store.getters.getActiveCommunity.id,
        filters: routeParams
      });
    }
  },
  destroyed() {
    //unsetting badge when view is closed
    //this.unsetTableData();
    this.setTableBadge('');
    document.removeEventListener('click', this.closeFilter);
  },
  methods: {
    ...mapMutations(['cardOpened', 'loadingStarted', 'loadingFinished']),
    ...mapMutations('modal', [
      'showModal',
      'showModalWider',
      'setInfrastructureCategories'
    ]),
    ...mapMutations('table', [
      'setTableBadge',
      'unsetTableData',
      'setTableData'
    ]),
    ...mapActions('table', [
      'getAllInfrastructure',
      'getCommunityReminders',
      'getAllContractors'
    ]),
    openFilter() {
      this.dropdownActive = !this.dropdownActive;
      if (this.dropdownActive) {
        document.addEventListener('click', this.closeFilter);
      } else {
        document.removeEventListener('click', this.closeFilter);
      }
    },
    closeFilter(e) {
      if (!this.$refs.filterDropdown.contains(e.target)) {
        this.dropdownActive = false;
        document.removeEventListener('click', this.closeFilter);
      }
    },
    refreshTableAndFilterDropdown() {
      this.selectedContractor = -1;
      this.selectedCategory = -1;
      this.dateFrom = null;
      this.dateTo = null;
      this.includeDeletedReminders = false;
      this.filterChange();
      this.dropdownActive = false;
      this.filterActive = false;
    },
    filterChange() {
      this.loadingStarted();
      if (
        this.selectedCategory == -1 &&
        this.selectedContractor == -1 &&
        this.dateTo == null &&
        this.dateFrom == null &&
        this.includeDeletedReminders == false
      ) {
        this.$router.push({
          name: 'communityReminders',
          params: {
            id: this.$store.getters.getActiveCommunity.id
          }
        });
        this.filterActive = false;
      } else {
        let filters = {};
        if (this.selectedCategory != -1) {
          filters['communityInfrastructureId'] = this.selectedCategory;
        }
        if (this.selectedContractor != -1) {
          filters['contractorId'] = this.selectedContractor;
        }
        if (this.dateFrom) {
          filters['dateFrom'] = DateTime.fromISO(this.dateFrom).toFormat(
            'yyyy-MM-dd'
          );
        }
        if (this.dateTo) {
          filters['dateTo'] = DateTime.fromISO(this.dateTo).toFormat(
            'yyyy-MM-dd'
          );
        }
        if (this.dateTo) {
          filters['dateTo'] = DateTime.fromISO(this.dateTo).toFormat(
            'yyyy-MM-dd'
          );
        }
        if (this.includeDeletedReminders) {
          filters['includeDeletedReminders'] = '1';
        }
        this.$router.push({
          name: 'communityReminders',
          params: {
            id: this.$store.getters.getActiveCommunity.id
          },
          query: filters
        });
        // this.getCommunityReminders({
        //   communityId: this.$store.getters.getActiveCommunity.id,
        //   filters: filters
        // });
        this.filterActive = true;
      }
      this.loadingFinished();
    },
    addNewReminder() {
      this.showModal('ModalContentAddReminder');
    },
    openReminderDetails(data) {
      this.$router.push({
        name: 'communityReminderDetails',
        params: {
          reminderId: data.row.id
        }
      });
    }
  }
};
</script>
<style lang="scss" scoped>
.dates {
  .validation-text {
    color: red;
    font-size: 12px;
  }
  .date {
    display: flex;
    align-items: center;
    align-content: center;
  }
  i {
    position: inherit !important;
    color: inherit;
  }
  i:hover {
    background: none;
    color: var(--primary-color);
  }
}
.incude-past-filter {
  display: flex;
  align-items: center;
  h6 {
    margin-bottom: 0;
    margin-right: 12px;
  }
}
.contractor-filter hr {
  border-top: 1px solid var(--primary-color-lighten);
}
.show-deleted-filter {
  display: flex;
  justify-content: space-between;
  align-items: center;
  h6 {
    margin-bottom: 0;
  }
}
.btn-filter {
  background: var(--primary-color);
  color: white;
  position: absolute;
  top: 0;
  left: 0;
  z-index: 1;
}
.btn-filter :focus :active {
  box-shadow: none;
}

.red-filter {
  background-color: #cc0033 !important;
}
.dropdown {
  position: absolute;
  right: 200px;
  width: 90px;
}

.dropdown-menu {
  width: 300px;
  padding: 1em 1em;
  border: 1px solid var(--primary-color);
  overflow: hidden;
}

.dropdown-menu.show {
  top: 38px;
}
#dropdownMenuButton {
  background: var(--primary-color);
  border: none;
}

#dropdownMenuButton:active:focus {
  box-shadow: 0 0 0 0.2rem var(--primary-color-lighten);
}

#dropdownMenuButton:focus {
  box-shadow: 0 0 0 0.2rem var(--primary-color-lighten);
}
.footer-filter {
  margin-top: 1rem;
  position: relative;
  display: flex;
  height: 35px;
}
.btn-go {
  margin-top: 5px;
  position: absolute;
  right: 0;
  &.left {
    left: 0;
    background: var(--primary-color);
  }
}
.btn-sort {
  margin-top: 5px;
  position: absolute;
  left: 0;
  background: var(--primary-color);
  color: white;
}
.radio-group {
  border: solid 1px var(--primary-color);
  display: inline-block;
  border-radius: 0.25rem;
  overflow: hidden;
  position: absolute;
  right: 306px;
  height: 36px;
  z-index: 10;
  //   margin-top: 1px;
  i {
    position: relative;
    border-radius: 0;
    height: 100%;
  }
  i:before {
    position: relative;
    top: 50%;
    transform: translateY(-50%);
    display: block;
  }
}
input[type='radio']:checked + i {
  color: white;
  background: var(--primary-color);
}

label + input[type='radio'] + i {
  border-left: solid 1px var(--primary-color);
}
i {
  color: var(--primary-color);
  display: inline-block;
  cursor: pointer;
  padding: 5px 20px;
  margin-bottom: 0;
  width: 3rem;
  height: 2rem;
  align-content: center;
  text-align: center;
}
input[type='radio'] {
  position: absolute;
  visibility: hidden;
  display: none;
}
.body-wrapper {
  display: block;
  padding: 10px 10px 4px 10px;

  .badge--mod {
    position: absolute;
    right: 0;
    left: unset;
    border-radius: 50%;
    padding: 5px;
    margin-right: 10px;
  }
}

.table-wrapper {
  position: relative;
}

.VuePagination {
  display: none;
}

h1,
h2 {
  text-align: center;
}

h1 {
  padding-top: 25px;
  position: relative;
}

h2 {
  color: #636363;
  padding-bottom: 20px;
}

i {
  padding: 5px;
  position: absolute;
  left: 0;
  cursor: pointer;
  border-radius: 50%;
  transition: background-color 0.25s;
}

i:hover {
  background-color: rgba(176, 178, 178, 0.5);
}

.spinner {
  padding-top: 10%;
}

// .btn {
//   background: var(--primary-color);
//   color: white;
//   position: absolute;
//   top: 0;
//   left: 0;
//   z-index: 1;
// }

.btn:focus {
  box-shadow: none;
}
</style>
